import { useEffect, useState, useCallback, useRef } from 'react';
import { workTicketsApi } from '../utils/api';

const POLL_INTERVAL_MS = 30000;
const UNKNOWN = { loading: true, setUp: false, online: false, cashDrawer: false };

// The shop's receipt printer and cash drawer (the Bouqmark Print Client's
// receipt printer role), from /work-tickets/print-clients/status: online and
// cashDrawer come from the print client's heartbeat; setUp once the shop has
// ever had one (until then the status has no receiptPrinter at all).
// `enabled` false: nothing is fetched (shops without the cash register).
export default function useReceiptPrinterStatus(enabled = true) {
  const [status, setStatus] = useState(UNKNOWN);
  const mounted = useRef(true);

  const fetchStatus = useCallback(async () => {
    try {
      const res = await workTicketsApi.getStatus();
      if (!mounted.current) return;
      const r = res && res.receiptPrinter;
      setStatus({
        loading: false,
        setUp: Boolean(r && r.setUp),
        online: Boolean(r && r.online),
        cashDrawer: Boolean(r && r.cashDrawer),
      });
    } catch (_) {
      if (!mounted.current) return;
      setStatus((prev) => ({ ...prev, loading: false, online: false, cashDrawer: false }));
    }
  }, []);

  useEffect(() => {
    mounted.current = true;
    if (!enabled) return () => { mounted.current = false; };
    fetchStatus();
    const interval = setInterval(fetchStatus, POLL_INTERVAL_MS);
    const onFocus = () => fetchStatus();
    window.addEventListener('focus', onFocus);
    return () => {
      mounted.current = false;
      clearInterval(interval);
      window.removeEventListener('focus', onFocus);
    };
  }, [enabled, fetchStatus]);

  return { ...status, refresh: fetchStatus };
}
